@if (adminsPage) {
  <mat-nav-list>
    <h3 class="subheader">
      Admins
      @if (!adminsPage.isEmpty()) {
        <zah-sort-button
          [sortOrder]="initialPageRequest.getSortOrder()"
          (sortOrderChange)="onSortOrderChange($event)">
        </zah-sort-button>
      }
    </h3>
    @for (admin of adminsPage.getItems(); track admin) {
      <mat-list-item (click)="onAdminClick(admin)">
        <zah-avatar matListItemAvatar [name]="admin.getNaam()"></zah-avatar>
        <div matListItemTitle>{{ admin.getNaam() }} <span class="mat-small">({{ admin.getPersoneelsnummer() }})</span>
      </div>
      <div matListItemLine class="mat-small">{{ admin.getEmail() }}</div>
      <button matListItemMeta
        disableRipple="true"
        class="center-vertically"
        mat-icon-button
        (click)="$event.stopPropagation(); onDeleteClick(admin)">
        <mat-icon>delete_outline</mat-icon>
      </button>
    </mat-list-item>
    <mat-divider></mat-divider>
  }
  @if (adminsPage.isEmpty()) {
    <mat-list-item
      class="no-list-item-highlight"
      disableRipple>
      <div matListItemTitle>Geen admins gevonden</div>
    </mat-list-item>
  }
  <mat-list-item class="no-list-item-highlight overflow-visible-for-button-shading"
    disableRipple
    lines="2">
    <span matListItemMeta class="center-vertically">
      <button mat-mini-fab
        color="accent"
        (click)="onAddClick()">
        <mat-icon>add</mat-icon>
      </button>
    </span>
  </mat-list-item>
</mat-nav-list>
@if (!adminsPage.isEmpty()) {
  <zah-paginator
    [currentPage]="adminsPage"
    [pageSize]="initialPageRequest.getPageSize()"
    (pageSizeChange)="onPageSizeChange($event)"
    (pageChange)="onPageChange($event)">
  </zah-paginator>
}
}
